
// import React, { useEffect, useState } from 'react';
// import axios from 'axios';

// const CryptoNews = () => {
//   const BaseUrl = process.env.REACT_APP_API;
//   const [news, setNews] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [newsPerPage] = useState(5); 

//   useEffect(() => {
//     const fetchNews = async () => {
//       try {
//         const response = await axios.get('https://min-api.cryptocompare.com/data/v2/news/?lang=EN');
//         setNews(response.data.Data);
//         setLoading(false);
//       } catch (error) {
//         console.error('Error fetching news:', error);
//         setLoading(false);
//       }
//     };
  
//     // Initial fetch
//     fetchNews();
  
//     const intervalId = setInterval(fetchNews, 300000);
  
//     return () => clearInterval(intervalId);
//   }, []);
  

//   const indexOfLastNews = currentPage * newsPerPage;
//   const indexOfFirstNews = indexOfLastNews - newsPerPage;
//   const currentNews = news?.slice(indexOfFirstNews, indexOfLastNews);

//   const paginate = (pageNumber) => setCurrentPage(pageNumber);

//   const convertToIST = (epochTime) => {
//     const date = new Date(epochTime * 1000);
//     const options = {
//       weekday: 'long',
//       year: 'numeric',
//       month: 'long',
//       day: 'numeric',
//       hour: 'numeric',
//       minute: 'numeric',
//       second: 'numeric',
//       hour12: true,
//       timeZone: 'Asia/Kolkata',
//     };
//     return new Intl.DateTimeFormat('en-IN', options).format(date);
//   };


//   if (loading) {
//     return <p className="loading-text">
//       Loading news...</p>;
//   }

//   return (
//     <div style={{ width: "100%", margin: "0", padding: "20px" }}>
//   <div className="card h-100 radius-8 border" style={{ width: "100%" }}>
//     <div className="card-body p-24">
//       <div className="crypto-news-container">
//         <ul className="news-list">
//           {currentNews?.map((item) => (
//             <li
//               key={item.id}
//               className="news-item"
//               style={{
//                 display: 'flex',
//                 alignItems: 'center',
//                 marginBottom: '20px',
//                 flexWrap: 'wrap', // Ensure items wrap on smaller screens
//               }}
//             >
//               <img
//                 src={item.imageurl}
//                 alt={'img'}
//                 style={{
//                   width: '120px',
//                   height: '120px',
//                   objectFit: 'contain',
//                   marginRight: '15px',
//                   flexShrink: 0, // Prevent the image from shrinking on small screens
//                 }}
//               />
//               <div style={{ flex: 1 }}>
//                 <h6 className="text-primary-light" style={{ margin: '0 0 8px 0' }}>{item.title}</h6>
//                 <a href={item.url} target="_blank" rel="noopener noreferrer" className="news-item-link">
//                   Read more
//                 </a>
//                 <p>{convertToIST(item.published_on)}</p>
//               </div>
//             </li>
//           ))}
//         </ul>

//         <div className="pagination">
//           {Array.from({ length: Math.ceil(news.length / newsPerPage) }, (_, index) => (
//             <button
//               key={index}
//               onClick={() => paginate(index + 1)}
//               className={`pagination-button ${currentPage === index + 1 ? 'active' : ''}`}
//             >
//               {index + 1}
//             </button>
//           ))}
//         </div>
//       </div>
//     </div>
//   </div>
// </div>
  
//   );
// };

// export default CryptoNews;



import React, { useEffect, useState } from "react";
import axios from "axios";

const CryptoNews = () => {
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [newsPerPage] = useState(5);
  const [selectedNews, setSelectedNews] = useState(null);

  useEffect(() => {
    const fetchNews = async () => {
      try {
        const response = await axios.get(
          "https://min-api.cryptocompare.com/data/v2/news/?lang=EN"
        );
        setNews(response.data.Data);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching news:", error);
        setLoading(false);
      }
    };

    fetchNews();
    const intervalId = setInterval(fetchNews, 300000);
    return () => clearInterval(intervalId);
  }, []);

  const indexOfLastNews = currentPage * newsPerPage;
  const indexOfFirstNews = indexOfLastNews - newsPerPage;
  const currentNews = news?.slice(indexOfFirstNews, indexOfLastNews);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const convertToIST = (epochTime) => {
    const date = new Date(epochTime * 1000);
    const options = {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      second: "numeric",
      hour12: true,
      timeZone: "Asia/Kolkata",
    };
    return new Intl.DateTimeFormat("en-IN", options).format(date);
  };

  if (loading) {
    return <p className="loading-text">Loading news...</p>;
  }

  return (
    <div style={{ width: "100%", margin: "0", padding: "20px" }}>
      <div className="card h-100 radius-8 border" style={{ width: "100%" }}>
        <div className="card-body p-24">
          <div className="crypto-news-container">
            <ul className="news-list">
              {currentNews?.map((item) => (
                <li
                  key={item.id}
                  className="news-item"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginBottom: "20px",
                    flexWrap: "wrap",
                  }}
                >
                  <img
                    src={item.imageurl}
                    alt="news"
                    style={{
                      width: "120px",
                      height: "120px",
                      objectFit: "contain",
                      marginRight: "15px",
                      flexShrink: 0,
                    }}
                  />
                  <div style={{ flex: 1 }}>
                    <h6
                      className="text-primary-light"
                      style={{ margin: "0 0 8px 0" }}
                    >
                      {item.title}
                    </h6>
                    <button
                      onClick={() => setSelectedNews(item)}
                      className="news-item-link"
                      style={{
                        background: "none",
                        border: "none",
                        color: "blue",
                        cursor: "pointer",
                        // textDecoration: "underline",
                      }}
                    >
                      Read more
                    </button>
                    <p>{convertToIST(item.published_on)}</p>
                  </div>
                </li>
              ))}
            </ul>

            <div className="pagination" style={{
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "center",
  gap: "5px",
  marginTop: "10px",
}}>
  {Array.from({ length: Math.ceil(news.length / newsPerPage) }, (_, index) => (
    <button
      key={index}
      onClick={() => paginate(index + 1)}
      className={`pagination-button ${currentPage === index + 1 ? "active" : ""}`}
      style={{
        padding: "6px 12px",
        fontSize: "14px",
        borderRadius: "4px",
        border: "1px solid #ccc",
        cursor: "pointer",
        background: currentPage === index + 1 ? "#007bff" : "#f8f9fa",
        color: currentPage === index + 1 ? "#fff" : "#000",
        minWidth: "30px",
        transition: "all 0.3s ease",
      }}
    >
      {index + 1}
    </button>
  ))}
</div>

          </div>
        </div>
      </div>

      {/* News Modal */}
      {selectedNews && (
        <div
          className="modal-overlay"
          onClick={() => setSelectedNews(null)}
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0, 0, 0, 0.7)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000,
          }}
        >
          <div
            className="modal-content"
            onClick={(e) => e.stopPropagation()}
            style={{
              background: "#fff",
              padding: "20px",
              borderRadius: "10px",
              maxWidth: "80%",
              maxHeight: "80%",
              overflow: "auto",
              position: "relative",
            }}
          >
            <button
              onClick={() => setSelectedNews(null)}
              style={{
                position: "absolute",
                top: "10px",
                right: "10px",
                border: "none",
                background: "red",
                color: "white",
                padding: "5px 10px",
                cursor: "pointer",
                borderRadius: "5px",
              }}
            >
              X
            </button>
            <h2>{selectedNews.title}</h2>
            <p>{convertToIST(selectedNews.published_on)}</p>
            <p>{selectedNews.body}</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default CryptoNews;







